import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./price-info.css";

export function PriceInfo({
    currentPriceHtml,
    // note: formattedPrice is the previous price if eg on sale. the "real" price is currentPrice
    formattedPrice,
    isInStock,
    isOnSale,
    leadUrl,
    retailerLabelSafeHtml,
    selectedShipping,
    isExpressCheckout,
}) {
    // If it's out of stock, it's not on sale
    if (!isInStock) {
        isOnSale = false;
    }

    let shippingCostLabel = "";
    let guaranteedFreeShipping = false;
    if (selectedShipping) {
        if (selectedShipping.is_free) {
            guaranteedFreeShipping = true;
            shippingCostLabel = gettext("general.free_shipping");
        } else {
            shippingCostLabel = gettext("in_stock_product.shipping_cost", {
                shipping_cost: selectedShipping.formatted_price,
            });
        }
    }

    return (
        <div className={styles.priceArea}>
            <span className={styles.bothPrices}>
                <span
                    className={classnames(styles.price, {
                        [styles.oos]: !isInStock,
                    })}
                    dangerouslySetInnerHTML={{ __html: currentPriceHtml }}
                />
                {isOnSale && (
                    <span className={styles.originalPrice}>
                        {" "}
                        <del>{formattedPrice}</del>
                    </span>
                )}
            </span>
            {shippingCostLabel && (
                <span className={classnames(styles.shippingCost)}>
                    {guaranteedFreeShipping && (
                        <SVGIcon name="truck" className={styles.freeShippingIcon} />
                    )}
                    <span className={styles.shippingCostLabel}>{shippingCostLabel}</span>
                </span>
            )}
            {!isExpressCheckout && (
                <div className={styles.retailArea}>
                    <LeadLink reason="retailer-link" href={leadUrl}>
                        <span
                            className={styles.retailer}
                            dangerouslySetInnerHTML={retailerLabelSafeHtml}
                        />
                    </LeadLink>
                </div>
            )}
        </div>
    );
}

PriceInfo.propTypes = {
    currentPriceHtml: PropTypes.string.isRequired,
    formattedPrice: PropTypes.string.isRequired,
    isInStock: PropTypes.bool,
    isOnSale: PropTypes.bool.isRequired,
    leadUrl: PropTypes.string.isRequired,
    retailerLabelSafeHtml: PropTypes.object,
    selectedShipping: ShippingOptionPropType,
    isExpressCheckout: PropTypes.bool,
};

PriceInfo.defaultProps = {
    isInStock: true,
};

export default PriceInfo;
